import { all, takeEvery, call, put } from 'redux-saga/effects';

import { meActionWatcher } from './MeSagas';
import { repositoryActionWatcher } from './RepositorySagas';
import { queryBuilderActionWatcher } from './QueryBuilderSagas';
import { taxonomyActionWatcher } from './TaxonomySagas';
import { demographicActionWatcher } from './DemographicSagas';
import { exploreItemsActionWatcher } from './ExploreItemsSaga';
import { reportErrorActionWatcher } from './ReportErrorSagas';
import { tsvActionWatcher } from './TsvSagas';
import { tabsActionWatcher } from './TabsSagas';

import { ADD_TOAST, REMOVE_TOAST } from '../constants/action-types';
import { conversationActionWatcher } from './ConversationSagas';
import { websocketActionWatcher } from './WebSocketSagas';
import { supportActionWatcher } from './SupportSagas';
import { accountsActionWatcher } from './AccountsSagas';
import { shareQueryActionWatcher } from './ShareQuerySagas';
import { eventsActionWatcher } from './EventsSagas';
import { membershipWatcher } from './MembershipSagas';

const delay = time => new Promise(resolve => setTimeout(resolve, time));

function* autoHideToast(data) {
  const { id } = data;
  yield call(delay, 5000);
  yield put({ type: REMOVE_TOAST, id });
}

function* actionWatcher() {
  yield takeEvery(ADD_TOAST, autoHideToast);
}

export default function* rootSaga() {
  yield all([
    actionWatcher(),
    meActionWatcher(),
    repositoryActionWatcher(),
    queryBuilderActionWatcher(),
    taxonomyActionWatcher(),
    demographicActionWatcher(),
    exploreItemsActionWatcher(),
    reportErrorActionWatcher(),
    tabsActionWatcher(),
    conversationActionWatcher(),
    websocketActionWatcher(),
    tsvActionWatcher(),
    supportActionWatcher(),
    accountsActionWatcher(),
    shareQueryActionWatcher(),
    eventsActionWatcher(),
    membershipWatcher(),
  ]);
}
